<template>
    <div class="scene">

        {{backgroundImage}}

        <PreloadedImage v-if="backgroundImage" class="scene__background-image" :src="mediaUrl(backgroundImage)"/>

        <video 
          v-if="backgroundVideo"
          :src="mediaUrl(backgroundVideo)"
          class="scene__background-video"
          muted
          autoplay
          loop
          playsinline
          webkit-playsinline
          type="video/mp4"
          @contextmenu.prevent=""></video>

        <div class="scene__contents">
              <slot></slot>
        </div>

    </div>
</template>


<script>
import PreloadedImage from '@/components/PreloadedImage'

export default {
  name: 'Scene',
  components: {
    PreloadedImage
  },
  props: {
      backgroundImage: String,
      backgroundVideo: String
  },
  methods:
  {
    mediaUrl(image)
    {
      return image;
    }
  }
}
</script>
